module.exports = __webpack_public_path__ + "img/prayer-journal_B095GJVX9W.a55a8765.jpg";